import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Tooltip from 'components/tooltip';

const SponsorReservePriceInfo = () => {
    return (
        <Tooltip.Root>
            <Tooltip.Trigger asChild>
                <FontAwesomeIcon icon={faQuestionCircle} className="cursor-help text-gray-500" />
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse>
                    <div className="text-xs">
                        Lowest acceptable winning price for this item. Items that do not reach their
                        set reserve price have no winning bidder. A 2.9% processing fee is applied
                        to the difference between the purchase price and the default reserve price.
                        Donors have the option to cover the processing fee.
                    </div>
                    <Tooltip.Arrow inverse />
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

export { SponsorReservePriceInfo };
